/* eslint-disable no-param-reassign */
import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";

export type ChfarShopParamsSliceState = {
  values: {
    itineraryId: string | null;
    contractId: string | null;
    tripCategory: string | null;
    origin: string | null;
    originRegionType: string | null;
    departureDate: string | null;
    destination: string | null;
    destinationRegionType: string | null;
    returnDate: string | null;
  };
};

export const initialState: ChfarShopParamsSliceState = {
  values: {
    itineraryId: null,
    contractId: null,
    tripCategory: null,
    origin: null,
    originRegionType: null,
    departureDate: null,
    destination: null,
    destinationRegionType: null,
    returnDate: null,
  },
};

const chfarShopParamsSlice = createSlice({
  name: "chfarShopParams",
  initialState,
  reducers: {
    setChfarShopParams(
      shopParams,
      action: PayloadAction<ChfarShopParamsSliceState["values"]>
    ) {
      shopParams.values = { ...shopParams.values, ...action.payload };
    },
  },
});

export const { setChfarShopParams } = chfarShopParamsSlice.actions;

export default chfarShopParamsSlice.reducer;
